<template>
  <a-modal
    title="拉取授权"
    centered
    :width="640"
    :mask-closable="false"
    :visible="showForm"
    :confirmLoading="loading"
    @cancel="close"
  >
    <a-form-model
      ref="form"
      :model="model"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-spin :spinning="loading">
        <a-form-model-item label="授权账号" prop="account_id">
          <a-select placeholder="请选择" show-search option-filter-prop="children" v-model="model.account_id">
            <template v-if="accounts.length > 0">
              <a-select-option :value="account.id" v-for="account in accounts" :key="account.id">
                {{ account.name }}
              </a-select-option>
            </template>
          </a-select>
        </a-form-model-item>
        <a-alert
          type="info"
          show-icon
          message="将跳转快手短剧经营者平台授权页（oauth_type=series，scope=ad_series），授权完成后自动回写授权记录。"
        />
      </a-spin>
    </a-form-model>

    <template slot="footer">
      <a-button @click="close" :disabled="loading">取消</a-button>
      <a-button type="primary" @click="submit" :disabled="loading">确定</a-button>
    </template>
  </a-modal>
</template>

<style lang="less" scoped>
.pull-form-tip {
  margin-top: 8px;
}
</style>

<script>
import { getMediaAccounts } from '@/api/open'
import { pullKsSeriesAuthorization } from '@/api/ks-series-authorization'

/**
 * 短剧经营者平台拉取授权弹窗（写法与快手广告模块的拉取一致）
 * oauth_type=series 与 scope=ad_series 由本模块后端固定，前端只需选择要授权的媒体账号。
 */
export default {
    props: {
        showForm: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            labelCol: { span: 4 },
            wrapperCol: { span: 18 },
            model: {},
            accounts: [],
            loading: false,
            rules: {
                account_id: [{ required: true, message: '请选择授权账号', trigger: 'change' }]
            }
        }
    },
    mounted() {
        this.loading = true
        // 只取短剧经营者(open_platform_type=2)的快手媒体账号，避免误选磁力引擎账号
        getMediaAccounts({ media: 1, open_platform_type: 2 }).then(res => {
            this.accounts = (res.data && res.data.list) || []
        }).finally(() => {
            this.loading = false
        })
    },
    methods: {
        submit() {
            this.$refs.form.validate(valid => {
                if (!valid) {
                    return false
                }
                this.pull()
            })
        },
        pull() {
            window.open(pullKsSeriesAuthorization(this.model.account_id))
            this.close()
        },
        close() {
            this.$emit('update:showForm', false)
            this.$refs.form.resetFields()
        }
    }
}
</script>
